import { Link } from 'react-router-dom'

import { StepBadge } from './StepBadge'
import { StepChip } from './StepChip'
import type { StepStatusType } from './utils'

export function StepItem({
	step,
	index,
	status,
	active,
	to,
}: {
	step: { label: string }
	index: number
	status: StepStatusType
	active: boolean
	to: string
}) {
	return (
		<li className="flex items-center">
			<Link
				to={to}
				aria-current={active ? 'page' : undefined}
				className={'flex w-full min-w-0 items-center gap-3 rounded-lg px-1 py-1 transition-colors'}
			>
				<StepBadge status={status} number={index + 1} />
				<div className="min-w-0 flex-1">
					<span
						className={`text-small lg:text-medium text-default-foreground transition-[color,opacity] duration-300 ${status === 'complete' ? 'opacity-70' : ''} ${active ? 'font-bold' : 'font-medium'}`}
					>
						{step.label}
					</span>
					<div className="mt-1">
						<StepChip status={status} />
					</div>
				</div>
			</Link>
		</li>
	)
}
